import { ComputedValueGetter } from "../../../../utils/ComputedValueGetter.js";

const navigator = globalThis.navigator;
const navigatorUserAgent = navigator?.userAgent ?? navigator?.vendor ?? "";
const MAX_WIDTH_OR_HEIGHT_FOR_MOBILE = 1000 as const;

/**
 * Check the userAgent string to see if it matches any known mobile device.
 * This is an older method and not preferred if a newer method is available.
 **/
export function isMobileDeviceLegacy ({
  userAgent = navigatorUserAgent,
  screenWidth = globalThis.screen.width,
  screenHeight = globalThis.screen.height,
  maxWidthOrHeightForMobile = MAX_WIDTH_OR_HEIGHT_FOR_MOBILE
}: {
  userAgent?: string,
  screenWidth?: number,
  screenHeight?: number,
  maxWidthOrHeightForMobile?: number
} = {}): boolean
{
  const userAgentLower = userAgent.toLowerCase();
  const hasSmallScreen = Math.min(screenWidth, screenHeight) <= maxWidthOrHeightForMobile;
  return hasSmallScreen && [ "mobi", "iphone", "ipad", "android" ].some(m => userAgentLower.includes(m));
}

export const IsMobileDeviceLegacy = new ComputedValueGetter({
  isLazy: true,
  computeFn: () => isMobileDeviceLegacy()
});